export default "__VITE_ASSET__BbjGDli7__"